<template>
  <span class="section-menu" v-click-outside="closeMenu">
    <div class="action" v-on:click="emitOpenCancelTrackingCategoryConfirmationPopup" v-on:focusout="closeMenu">מחיקה מהתזרים</div>
  </span>
</template>

<script>
import Segment from '../../../../../../../../../../Segment';
import ModalBus from '../../../../../../../../../../event-bus/modal-bus';
import ClickOutside from '../../../../../../../../../../directives/click-outside';
import CancelTrackingCategoryConfirmationPopup from './CancelTrackingCategoryConfirmationPopup.vue';

export default {
  name: 'TrackingCategorySectionMenu',
  directives: {
    ClickOutside,
  },
  props: {
    categoryName: {
      type: String,
      required: true,
    },
    envelopeId: {
      type: String,
      required: true,
    },
    upToNowAmount: {
      type: Number,
      required: true,
    },
    closeMenu: {
      type: Function,
      required: true,
    },
  },
  methods: {
    emitOpenCancelTrackingCategoryConfirmationPopup() {
      Segment.trackUserInteraction('SectionMenu_CancelTrackingCategoryClicked', {
        trackingCategory: this.categoryName,
      });
      this.emitOpenPopup(CancelTrackingCategoryConfirmationPopup, {
        trackingCategory: this.categoryName,
        envelopeId: this.envelopeId,
        upToNowAmount: this.upToNowAmount,
      });
    },
    emitOpenPopup(component, props) {
      this.closeMenu();
      ModalBus.$emit('open', {
        component,
        props,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .section-menu {
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 13px;
    top: 12px;
    border-radius: 1px;
    background-color: $riseup_white;
    box-shadow: 2px 2px 8px 0 $riseup_gray_0;

    .action {
      display: flex;
      align-items: center;
      font-family: SimplerPro;
      font-size: 14px;
      padding: 0 8px;
      height: 30px;
      width: 100%;
      cursor: pointer;
      line-height: 27px;
    }
  }
</style>
